import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import { LoyaltyLeaderboardSection } from "Components/Loyalty/Shared/Leaderboard/LoyaltyLeaderboardSection";
import { LoyaltyPointType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

export const LeaderboardSection = () => {
  const { t } = useResource();

  return (
    <LoyaltyLeaderboardSection
      pointType={LoyaltyPointType.Valor}
      title={t(Resources.Pages.Content.Valor.Leaderboard.Title)}
      scoreIcon={<MilitaryTechIcon />}
    />
  );
};
